import { CommonModule } from '@angular/common';
import { isDevMode, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { L10nTranslationModule } from 'angular-l10n';
import { DxPopoverModule } from 'devextreme-angular';
import { AsLet } from './as-let/as-let.directive';

import { AsValidatorDirective } from './as-validator/as-validator.directive';
import { ShortcutDirective } from './button-shortcuts/button-shortcut-popover.directive';
import { DraggableDirective } from './draggable.directive';
import { SIGNALR_NOTIFICATION_HANDLER } from './notifications/notification-handler.interface';
import { NullSignalRNotificationHandler } from './notifications/null-signalr-notification-handler';
import { PageLoadingIndicatorComponent } from './page-loading-indicator/page-loading-indicator.component';
import { topBarServiceProvider } from './top-bar/top-bar-service.provider';
import { printMissingTranslationKeys } from './translation/print-missing-translation-keys';

/**
 * Components which are declared and exported in this module
 */
const components = [PageLoadingIndicatorComponent, AsValidatorDirective, ShortcutDirective, DraggableDirective, AsLet];

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, L10nTranslationModule, DxPopoverModule, ...components],
    exports: components,
    providers: [
        {
            provide: SIGNALR_NOTIFICATION_HANDLER,
            useClass: NullSignalRNotificationHandler,
            multi: true,
        },
        topBarServiceProvider,
    ]
})
export class AsamcoBaseModule {
	constructor() {
		// Register helper function on window to print missing translation keys
		if (isDevMode()) {
			printMissingTranslationKeys();
		}
	}
}
